'use strict';

import type { GlobProviderType } from '../../Entities/Glob/GlobProviderType';
import { EntityCollection } from '../EntityCollection';

export class GlobProviderTypeCollection extends EntityCollection<GlobProviderType> {}
